import ButtonBase from '@mui/material/ButtonBase';
import { Dispatch, SetStateAction, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import styles from './Calendar.module.css'
import { dateHasMeals, getDaysInWeek, getDisplayedMonths, isCurrentDate, isPastDate } from './utils';
import { ActiveMeal, BackIcon, Breakfast, CalendarIcon, Dinner, ForwardIcon, Lunch, Snacks } from '../../../iconRef/mealPLanIcons';
import { useAppDispatch, useAppSelector } from '../../../app/store/hooks';
import { setSelectedDate, UserMealPlanDataSelector } from '../../../app/mealPlan/mealPlan.slice';
import { Meal, MealNote } from '../mealPlan.types';
import useLogRecipeEdit from '../../../hooks/useLogRecipeEdit';
import { filterNotesByDate, getAdjustedDateTime } from '../utils';
import { IconButton } from '@mui/material';



const RenderCalendar = ({ currentDate, meals, disablePastDateSelection, selectedDate, daysOfWeek, onSelectedDateChange, notes }: { currentDate: Date, meals?: Meal[], disablePastDateSelection?: boolean, selectedDate: Date, daysOfWeek: string[], onSelectedDateChange?: (newSelectedDate: Date) => void, notes?: MealNote[] }) => {
  // const days = view === 'month' ? getDaysInMonth(currentDate) : getDaysInWeek(currentDate);
  const { logRecipeEdit } = useLogRecipeEdit();
  const userMealPlanData = useAppSelector(UserMealPlanDataSelector);
  const mealPlanId = userMealPlanData?.meal_plan_id;
  const handleDateChange = (newDate: Date) => {
    dispatch(setSelectedDate(newDate));
    onSelectedDateChange && onSelectedDateChange(newDate);
    logRecipeEdit("DATE_CHANGED", {
      meal_plan_id: mealPlanId,
      eventData: { new_date: newDate.toISOString() },
    });

  }
  const days = getDaysInWeek(currentDate);
  const dispatch = useAppDispatch()
  return (
    <Grid className={styles.calendar_grid}>
      {daysOfWeek.map((day: string) => (
        <Typography variant='caption4LightOutfit' key={day} className={styles.day_of_week}>
          {day}
        </Typography>
      ))}
      {days.map((day, index) => {
        const dayHasMeals = dateHasMeals(day, meals)
        const selectedDateNotes = filterNotesByDate(day, notes);

        const adjustedDate = getAdjustedDateTime();
        const disableButton = disablePastDateSelection && isPastDate(day, adjustedDate);
        return <ButtonBase disabled={disableButton} key={index} className={`${styles.day_cell} ${isCurrentDate(day, selectedDate) ? styles.day_cell_selected : ""} ${disableButton ? styles.day_cell_disabled : ""}`} onClick={() => handleDateChange(day)} >
          {dayHasMeals || selectedDateNotes.length >0 ? <ActiveMeal /> : null}
          {day ? day.getDate() : ''}
        </ButtonBase>
      })}
    </Grid>
  );
};

const Calendar = ({ meals, currentDate, setCurrentDate, selectedDate, disablePastDateSelection, onSelectedDateChange, notes }: { meals?: Meal[], currentDate: Date, setCurrentDate: Dispatch<SetStateAction<Date>>, selectedDate: Date, disablePastDateSelection?: boolean, onSelectedDateChange?: (newSelectedDate: Date) => void, notes?: MealNote[] }) => {
  // const [view, setView] = useState('month');
  const daysOfWeek = ['S', 'M', 'T', 'W', 'Th', 'F', 'Sa'];
  const datesOfWeek = getDaysInWeek(currentDate);
  const displayMonthName = getDisplayedMonths(datesOfWeek);

  // const changeMonth = (offset: number) => {
  //   const newDate = new Date(currentDate);
  //   newDate.setMonth(newDate.getMonth() + offset);
  //   setCurrentDate(newDate);
  // };

  const changeWeek = (offset: number) => {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + offset * 7);
    setCurrentDate(newDate);
  };

  const today = new Date()
  const hideBackButton = disablePastDateSelection && datesOfWeek[0] < today; //dont show back button when the first day of the week is in the past

  return (
    <Grid className={styles.container}>
      <Grid className={styles.header}>
        <Grid className={styles.header_left}>
          {hideBackButton ? null : <IconButton className={styles.toggle_icon} onClick={() => changeWeek(-1)}>
            <BackIcon />
          </IconButton>}
          <Grid className={styles.calendar_month}>

            <CalendarIcon />
            <Typography variant='caption4LightOutfit'>
              {displayMonthName}
            </Typography>
          </Grid>
        </Grid>

        <IconButton className={styles.toggle_icon} onClick={() => changeWeek(1)}>
          <ForwardIcon />
        </IconButton>
      </Grid>
      <RenderCalendar currentDate={currentDate} disablePastDateSelection={disablePastDateSelection} selectedDate={selectedDate} daysOfWeek={daysOfWeek} meals={meals} onSelectedDateChange={onSelectedDateChange} notes={notes} />
    </Grid>
  );
};

export default Calendar;
